import clsx from 'clsx';
import LoadingSpinner from './LoadingSpinner';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  loading = false,
  disabled = false,
  active = false,
  type = 'button',
  className = '',
  onClick,
  ...props
}) => {
  const baseClasses =
    'inline-flex items-center justify-center font-semibold rounded-md transition-all whitespace-nowrap outline-none focus:outline-none focus-visible:outline-none disabled:opacity-50 disabled:cursor-not-allowed';

  const variantClasses = {
    primary:
      'bg-navbar text-white border border-navbar hover:bg-navbar-hover',
    secondary:
      'bg-secondary-600 text-white border border-secondary-600 hover:bg-secondary-700',
    outline:
      'bg-white border border-navbar text-navbar hover:bg-primary-50',
    ghost:
      'text-primary-700 hover:bg-primary-50',
    danger:
      'bg-secondary-600 text-white border border-secondary-600 hover:bg-secondary-700',
    /**
     * Pill / Tab style — used for category tabs, sub-domain chips, filter
     * groups, etc. Toggle the `active` prop to switch between selected
     * (red) and unselected (white/border) states. Uses 1px border.
     */
    pill: active
      ? 'bg-secondary-600 text-white border border-secondary-600'
      : 'bg-white text-gray-700 border border-gray-200 hover:border-secondary-400 hover:text-secondary-600',
  };

  const sizeClasses = {
    sm: 'px-3 py-1 text-xs',
    md: 'px-3.5 py-1.5 text-xs sm:text-[13px]',
    lg: 'px-5 py-2.5 text-sm sm:text-base',
  };

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={clsx(
        baseClasses,
        variantClasses[variant],
        sizeClasses[size],
        fullWidth && 'w-full',
        className
      )}
      {...props}
    >
      {loading && <LoadingSpinner size="sm" className="mr-2" />}
      {children}
    </button>
  );
};

export default Button;
